import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import CountriesList from '../components/CountriesList'

export default function Countries() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  return (
    <div className='eczmembers'>
      <div className="memberTitleContainer">
        <h1 className="newMemberTitle">Countries</h1>
        <Link to="/new-country"><button className="memberAddButton">Add New</button></Link>
      </div>
        <CountriesList />
    </div>
  )
}
